import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "bg-white px-6 mt-6" };
const _hoisted_2 = { class: "grid grid-cols-2 gap-3" };
const _hoisted_3 = { class: "text-center" };
const _hoisted_4 = { class: "text-xs text-gray-600 mt-1 font-medium" };
const _hoisted_5 = { class: "text-center" };
const _hoisted_6 = { class: "text-xs text-gray-600 mt-1 font-medium" };
import { inject, computed } from 'vue';
import { useCheckoutStore } from '@shared';
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderTypeSelection',
    props: {
        modelValue: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const checkoutStore = useCheckoutStore();
        // Get theme config - with fallback to default red
        const projectConfig = inject('projectConfig', null);
        const themePrimaryColor = computed(() => projectConfig?.branding?.colors?.primary || '#DC2626');
        function updateValue(value) {
            checkoutStore.setOrderType(value);
            emit('update:modelValue', value);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = ($event) => (updateValue('pickup'))),
                        class: _normalizeClass(["flex items-center justify-center gap-3 p-4 border-2 rounded-xl transition-all duration-200 shadow-sm font-semibold", _ctx.modelValue !== 'pickup' ? 'border-gray-300 hover:bg-gray-50 text-gray-700' : '']),
                        style: _normalizeStyle(_ctx.modelValue === 'pickup' ? {
                            borderColor: themePrimaryColor.value,
                            backgroundColor: themePrimaryColor.value + '15',
                            color: themePrimaryColor.value
                        } : {})
                    }, [
                        _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fas fa-walking text-xl" }, null, -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_3, [
                            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "font-semibold" }, "Abholung", -1 /* CACHED */)),
                            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(checkoutStore).pickupTime), 1 /* TEXT */)
                        ])
                    ], 6 /* CLASS, STYLE */),
                    _createElementVNode("button", {
                        onClick: _cache[1] || (_cache[1] = ($event) => (updateValue('delivery'))),
                        class: _normalizeClass(["flex items-center justify-center gap-3 p-4 border-2 rounded-xl transition-all duration-200 shadow-sm font-semibold", _ctx.modelValue !== 'delivery' ? 'border-gray-300 hover:bg-gray-50 text-gray-700' : '']),
                        style: _normalizeStyle(_ctx.modelValue === 'delivery' ? {
                            borderColor: themePrimaryColor.value,
                            backgroundColor: themePrimaryColor.value + '15',
                            color: themePrimaryColor.value
                        } : {})
                    }, [
                        _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fas fa-motorcycle text-xl" }, null, -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_5, [
                            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "font-semibold" }, "Lieferung", -1 /* CACHED */)),
                            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(checkoutStore).deliveryTime), 1 /* TEXT */)
                        ])
                    ], 6 /* CLASS, STYLE */)
                ])
            ]));
        };
    }
});
